import { Skeleton } from '@shared/ui';

import styles from './ResultCard.module.css';

/**
 * Плейсхолдер карточки результата.
 *
 * Повторяет геометрию `ResultCard`, поэтому появление данных ничего не сдвигает.
 * Скрыт от скринридеров: о загрузке сообщает статус-строка списка.
 */
export function ResultCardSkeleton() {
  return (
    <div className={`${styles.card} ${styles.skeletonCard}`} aria-hidden="true">
      <div className={styles.link}>
        <div className={styles.skeletonMedia}>
          <Skeleton height="100%" radius="0" />
        </div>

        <div className={styles.body}>
          <div className={styles.head}>
            <div className={styles.identity}>
              <Skeleton height="1.25rem" width="12rem" />
              <Skeleton height="0.85rem" width="8rem" />
            </div>
            <Skeleton height="4.25rem" width="4.25rem" radius="var(--radius-full)" />
          </div>

          <div className={styles.skeletonSpecs}>
            <Skeleton height="0.85rem" width="70%" />
            <Skeleton height="0.85rem" width="80%" />
            <Skeleton height="0.85rem" width="60%" />
            <Skeleton height="0.85rem" width="75%" />
            <Skeleton height="0.85rem" width="65%" />
            <Skeleton height="0.85rem" width="55%" />
          </div>

          <Skeleton height="0.85rem" width="90%" />
          <Skeleton height="0.85rem" width="75%" />

          <div className={styles.footer}>
            <Skeleton height="1.5rem" width="40%" />
            <Skeleton height="0.85rem" width="25%" />
          </div>
        </div>
      </div>
    </div>
  );
}
